// extracted by mini-css-extract-plugin
module.exports = {"searchModalButton":"styles_base_searchModalButton__6EKIu","searchIcon":"styles_base_searchIcon__haD84"};